import * as React from 'react';

import { cn } from 'lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string; // Accept but ignore for compatibility
  icon?: React.ReactNode; // Accept but ignore for compatibility
  hint?: string; // Accept but ignore for compatibility
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, icon, hint, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // text-base (16px) on mobile prevents iOS Safari's focus-zoom; md:text-sm restores the denser desktop size.
          'flex h-9 w-full rounded-md border border-input bg-card px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
